// @flow

import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core/';
import { type ApiNamingconvertion } from '../../../../data/cms/types/api-docs';
import DocsTables from '../../../table';

type Props = {
    Content: ApiNamingconvertion
};
function Data(props: Props) {
    const { Content } = props;
    return (
        <>
            <Typography component="div" id={Content.RefName}>
                <>
                    <Typography component="h5">{Content.Title}</Typography>
                    <Typography component="p">{Content.Content}</Typography>
                    <DocsTables>{Content.Convertion.Convertions}</DocsTables>
                </>
            </Typography>
        </>
    );
}
Data.propTypes = {
    Content: PropTypes.object.isRequired
};
export default Data;
